import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { VillageStaffComponent } from './village-staff.component';
import { WaviersComponent } from './waviers/waviers.component';
import { EnforcementComponent } from './enforcement/enforcement.component';
import { AddPermitComponent } from './add-permit/add-permit.component';
import { PermitComponent } from './permit/permit.component';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatSelectModule,
        SharedModule,
        MatTableModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTabsModule,
        MatPaginatorModule,
        MatSortModule,
        MatDialogModule,

    ],
    providers: [],
    exports: [
    ],
    declarations: [
        VillageStaffComponent,
        WaviersComponent,
        EnforcementComponent,
        AddPermitComponent,
        PermitComponent

    ]
})
export class VillageStaffModule { }
